// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateDTGVariant_closeButton__1LEQE"};